// START_MODULE components_organisms_navbar_styled_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled, { css } from 'styled-components';
import AnchorLinkExport from 'react-anchor-link-smooth-scroll';

const AnchorLink = (
  (AnchorLinkExport as unknown as { default?: typeof AnchorLinkExport }).default
  ?? AnchorLinkExport
) as typeof AnchorLinkExport;

const LOGO_SIZE = 70;

interface NavbarWrapperProps {
  $initial: boolean;
}

export const NavbarWrapper = styled.nav<NavbarWrapperProps>`
  ${({ $initial, theme }) => css`
    background-color: ${$initial ? 'transparent' : 'white'};
    width: 100%;

    display:flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 40px;

    @media (max-width: 600px) {
      flex-direction: column;
      gap: 0;
    }

    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    ${!$initial && css`
      box-shadow: 0 0 6px 3px rgba(0, 0, 0, 0.3);
    `};

    ul {
      list-style: none;
      display: flex;
      height: ${LOGO_SIZE + 4}px;

      @media (max-width: 1000px) {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        height: ${LOGO_SIZE + 14}px;
      }

      @media (max-width: 450px) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        height: ${LOGO_SIZE + 24}px;
      }
    }
  `};
`;

interface AnchorLinkStyledProps {
  $active?: boolean;
}

export const AnchorLinkStyled = styled(AnchorLink)<AnchorLinkStyledProps>`
  ${({ theme, $active }) => css`
    text-decoration: none;
    color: black;

    padding: 0 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: .2s border-bottom;
    overflow: hidden;

    position: relative;
    &::after {
      content: '';

      display: block;
      width: 100%;
      height: 4px;
      position: absolute;
      top: ${$active ? 'calc(100% - 4px)' : '100%'};
      left: 0;
      background-color: ${theme.accentColor};

      transition: .2s top ease-in-out;
    }
    &:hover::after {
      top: calc(100% - 4px);
    }
  `};
`;

export const Logo = styled.img`
  width: ${LOGO_SIZE}px;
  height: ${LOGO_SIZE}px;
`;

// END_MODULE components_organisms_navbar_styled_ts
